module.exports = __webpack_public_path__ + "img/parking_hover_c808781.webp";